<template lang="html">
  <PageNotFound></PageNotFound>
</template>

<script>

import PageNotFound from '@/components/PageNotFound.vue'

export default {
  components: {
    PageNotFound
  },
}
</script>

<style lang="css" scoped>
</style>
